<template>
  <section class="insuranceFixedFooter" :class="displayModeClass">
    <span
      v-if="displayMode === 'close'"
      v-ripple
      class="insuranceFixedFooter-display_btn"
      @click="handleDisplayMode('open')"
      >合計額表示</span
    >
    <span
      v-if="displayMode !== 'close'"
      v-ripple
      class="insuranceFixedFooter-display_btn insuranceFixedFooter-display_btn--open"
      @click="handleDisplayMode('close')"
      >閉じる <img src="image/icon_close.svg"
    /></span>

    <section class="insuranceFixedFooter-contain">
      <section
        v-if="displayMode !== 'close'"
        class="insuranceFixedFooter-header"
      >
        <section v-if="!isMobile" class="insuranceFixedFooter-grey">
          <a
            v-ripple
            href="https://www.hitachi-hoken.co.jp/information.html"
            target="_blank"
            class="insuranceFixedFooter-grey_btn"
          >
            <v-icon> mdi-phone </v-icon>
            <h5>お問い合わせ</h5>
            <icon-right />
          </a>
          <a
            v-ripple
            href="https://www.hitachi-hoken.co.jp/service/check.html"
            target="_blank"
            class="insuranceFixedFooter-grey_btn"
          >
            <img src="image/icon_clipboard.svg" />
            <h5>保険診断を ご希望の方</h5>
            <icon-right />
          </a>
        </section>
        <span
          v-ripple
          class="insuranceFixedFooter-expand_btn"
          @click="handleDisplayMode(displayMode === 'open' ? 'expand' : 'open')"
        >
          <h5>合計額の詳細</h5>
          <v-icon class="insuranceFixedFooter-expand_btn_icon">
            {{
              displayMode === 'expand' ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}
          </v-icon>
        </span>
        <section class="insuranceFixedFooter-total">
          <span class="insuranceFixedFooter-total_note">（ご参考）</span>
          <span class="insuranceFixedFooter-total_title"
            >合計保険料（月払）</span
          >
          <h3>
            <animated-number :number="totalInsurancePremium" /><span
              class="insuranceFixedFooter-total_unit"
              >円</span
            >
          </h3>
        </section>
        <span
          v-ripple
          class="insuranceFixedFooter-web_btn insuranceFixedFooter-web_btn--pc"
          @click="handleWeb"
        >
          <h2>WEB申込みはこちら</h2>
          <h5>WEB募集期間外は「お問い合わせ」 よりお問い合わせください。</h5>
        </span>
      </section>
      <transition-expand>
        <section
          v-if="displayMode === 'expand'"
          class="insuranceFixedFooter-data"
        >
          <table>
            <tbody>
              <tr>
                <th>NEW(希)保険</th>
                <td :class="{ 'no-data': insurancePremium === null }">
                  <span> 合計保険料(賞与払)</span>
                  <h3>
                    <animated-number :number="insurancePremium" /><em>円</em>
                  </h3>
                </td>
                <td :class="{ 'no-data': monthlyInsurancePremium === null }">
                  <span> （ご参考）月額換算</span>
                  <h3>
                    <mark>約</mark
                    ><animated-number :number="monthlyInsurancePremium" /><em
                      >円</em
                    >
                  </h3>
                </td>
              </tr>
              <tr>
                <th>団体医療保険制度</th>

                <td
                  :class="{ 'no-data': monthlyGroupMedicalInsurance === null }"
                  colspan="2"
                >
                  <h3>
                    <animated-number
                      :number="monthlyGroupMedicalInsurance"
                    /><em>円</em>
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </transition-expand>

      <section class="insuranceFixedFooter-note">
        <span v-if="insurancePremium !== null" >※「（ご参考）月額換算」欄で表示している数値はNEW（希）保険「賞与払（半年分）保険料」を6で割って1カ月当たりに換算したものを合計している額です</span>
      </section>
      <section v-if="isMobile" class="insuranceFixedFooter-grey--sp">
        <span v-ripple class="insuranceFixedFooter-grey_btn--sp">
          <v-icon> mdi-phone </v-icon>
          <h5>お問い合わせ</h5>
        </span>
        <span v-ripple class="insuranceFixedFooter-grey_btn--sp">
          <img src="image/icon_clipboard.svg" />
          <h5>保険診断をご希望の方</h5>
        </span>
      </section>
      <span
        v-ripple
        class="insuranceFixedFooter-web_btn insuranceFixedFooter-web_btn--sp"
        @click="handleWeb"
      >
        <h2>WEB申込みはこちら</h2>
        <h5>WEB募集期間外は「お問い合わせ」よりお問い合わせください。</h5>
      </span>
    </section>
  </section>
</template>

<script>
import TransitionExpand from '@/components/TransitionExpand.vue';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'InsuranceFixedFooter',
  components: { TransitionExpand },
  props: {
    insurancePremium: {
      type: Number,
      default: undefined,
    },
    monthlyInsurancePremium: {
      type: Number,
      default: undefined,
    },
    monthlyGroupMedicalInsurance: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      displayMode: 'open', // open, close, expand
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.common.isMobile,
    }),
    displayModeClass() {
      return `insuranceFixedFooter-${this.displayMode}`;
    },
    totalInsurancePremium() {
      if (this.insurancePremium === null && this.monthlyGroupMedicalInsurance === null) {
        return null;
      }
      let totalPremium = 0;
      totalPremium += this.monthlyInsurancePremium ? this.monthlyInsurancePremium : 0;
      totalPremium += this.monthlyGroupMedicalInsurance ? this.monthlyGroupMedicalInsurance : 0;
      return totalPremium;
    },
  },
  methods: {
    ...mapActions('dialog', ['openDialog']),
    handleDisplayMode(mode) {
      this.displayMode = mode;
    },
    handleWeb() {
      this.openDialog('web');
    },
  },
};
</script>

<style lang="scss" scoped>
.insuranceFixedFooter {
  box-shadow: 0px -4px 6px 0px rgb(0 0 0 / 10%);
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #fff;
  z-index: 2;
  & a {
    text-decoration: none;
  }
  &-display_btn {
    display: flex;
    justify-content: center;
    position: absolute;
    min-width: 94px;
    right: 7%;
    top: -30px;
    background-color: #fff;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #333;
    padding: 8px 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    box-shadow: -2px -5px 6px 1px rgb(0 0 0 / 10%);
    cursor: pointer;
    &--open {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #333;
      img {
        margin-left: 5px;
      }
    }
  }
  &-grey {
    display: flex;
    gap: 10px;
    &--sp {
      display: flex;
      gap: 10px;
      margin-top: 10px;
      padding: 0 10px;
    }

    &_btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 170px;
      height: 80px;
      padding-left: 19px;
      padding-right: 5px;
      border-radius: 5px;
      background-color: #f4f4f4;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #333;
      cursor: pointer;
      h5 {
        max-width: 84px;
      }
      .v-icon {
        font-size: 21px;
        color: #CC0000;
      }
      &--sp {
        display: flex;
        align-items: center;
        height: 40px;
        border-radius: 5px;
        background-color: #f4f4f4;
        padding: 11px 9px;
        &:first-child {
          width: 40%;
        }
        &:last-child {
          width: 60%;
        }
        h5 {
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.29;
          letter-spacing: normal;
          text-align: left;
          color: #333;
        }
        img {
          width: 18px;
          margin-right: 7px;
        }
        .v-icon {
          font-size: 21px;
          color: #CC0000;
          margin-right: 7px;
        }
      }
    }
  }
  &-expand_btn {
    width: 94px;
    height: 80px;
    border: solid 1px #ccc;
    background-color: #fff;
    border-radius: 5px;
    padding: 12px;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
    h5 {
      max-width: 39px;
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.4;
      letter-spacing: normal;
      color: #333;
      text-align: center;
      margin: 0 auto;
    }
    &_icon {
      color: #707070;
    }
  }
  &-total {
    height: 80px;
    max-width: 190px;
    margin-left: 20px;
    flex: 1;
    &_unit {
      margin-left: 3px;
    }
    &_note {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #333;
    }
    &_title {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: right;
      color: #333;
    }
    h3 {
      text-align: right;
      span {
        &:first-child {
          font-size: 30px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          color: #CC0000;
        }
        &:nth-child(2) {
          font-size: 20px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: right;
          color: #333;
        }
      }
    }
  }

  &-web_btn {
    width: 230px;
    height: 80px;
    border-radius: 5px;
    background-color: #CC0000;
    text-align: center;
    padding: 14px 30px;
    margin-left: 20px;
    &--sp {
      display: none;
      margin: 10px auto;
    }
    h2 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      margin: unset;
      padding: unset;
      background: unset;
    }
    h5 {
      font-size: 10px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #fff;
      padding-left: 11px;
      cursor: pointer;
      &::before {
        content: '※';
        display: inline-block; /* Needed to add space between the bullet and the text */
        width: 10px; /* Also needed for space (tweak if needed) */
        margin-left: -15px; /* Also needed for space (tweak if needed) */
      }
    }
  }

  &-header {
    display: flex;
    margin-top: 10px;
    gap: 10px;
    justify-content: space-between;
  }
  &-contain {
    max-width: 970px;
    margin: 0 auto;
  }
  &-data {
    margin-top: 10px;
    & > table {
      width: calc(100% - 254px);
      border: solid 4px #f4f4f4;
      height: 130px;
      margin: 0;
      td {
        border: solid 2px #f4f4f4;
        text-align: right;
        padding: 10px 20px;
        &.no-data {
          background-color: #f4f4f4;
        }
        span:not(.animatedNumber) {
          font-family: Meiryo;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: right;
          color: #333;
          margin-bottom: 5px;
          display: block;
        }
        h3 {
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.8;
          letter-spacing: normal;
          text-align: right;
          color: #333;
          margin-bottom: 0;
          margin-left: 5px;

          em,
          mark {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.14;
            letter-spacing: normal;
            text-align: right;
            color: #333;
          }
          em {
            margin-left: 5px;
          }
          mark {
            margin-right: 5px;
            background-color: transparent;
          }
        }
      }
      th {
        width: 50%;
        text-align: right;
        border: solid 1px #f4f4f4;
        background-color: #f4f4f4;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: right;
        color: #333;
      }
    }
  }
  &-note {
    font-size: 10px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: normal;
    text-align: left;
    color: #999;
    margin-top: 5px;
    padding-bottom: 5px;
  }

  &-close {
    height: 6px;
  }
  &-open {
    height: auto;
  }
  &-expand {
    height: auto;
  }
  // mobile
  @media screen and (max-width: 870px) {
    &-header {
      padding: 0 10px;
    }
    &-display_btn {
      right: 0;
      border-top-right-radius: 0;
    }
    &-web_btn {
      &--pc {
        display: none;
      }
      &--sp {
        display: block;
      }
    }
    &-data {
      padding: 0 10px;
      table {
        width: 100%;
      }
    }
    &-note {
      padding: 0 10px;
      margin-top: 0;
    }
  }
  @media screen and (max-width: 767px) {
    &-note {
      //display: none;
    }
    &-web_btn {
      &--sp {
        width: 100%;
        max-width: calc(100% - 20px);
        margin: 10px 10px;
        height: 50px;
        padding: 5px;
        h5 {
          text-align: center;
          font-size: 11px;
        }
      }
    }
    &-expand_btn {
      width: 110px;
      height: 66px;
      h5 {
        max-width: unset;
      }
    }
    table {
      th {
        width: auto;
        font-size: 12px;
        padding: 5px;
        text-align: left;
      }
      td {
        padding: 5px;
        span:not(.animatedNumber) {
          font-size: 11px;

          &.animatedNumber{
            font-size: 16px;
          }
        }
        h3 {
          font-size: 16px;
          em,
          mark {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
